import React from 'react'
import content from 'Content/content.json'
import { FormattedMessage } from 'react-intl'
import Slider from 'react-slick'
import { language } from 'Root/constants'
import Card from './Card'

import './lensCareGuide.scss'

const Container = ({id,title, type,active}) => {
  const data = content.data[type][language==='arabia_en'?'en':language]
  const settings = {
    arrows: false,
    className: 'center',
    centerMode: true,
    centerPadding: '20px',
    slidesToShow: 1,
    initialSlide: 0,
    infinite: 0,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <React.Fragment>
      <div className={`lcguide--wrapper${active}`}>
        <h2 className="lcguide--title">
          <FormattedMessage
            id={id}
            defaultMessage={title}
          />
        </h2>
        <ul className="lcguide--content lcguide--content__mobile">
          <Slider {...settings} className="lcguide--content__mobile">
            {data.map((item, index) => (
              <Card key={index} item={item} />
            ))}
          </Slider>
        </ul>
        <ul className="lcguide--content lcguide--content__desktop">
          {data.map((item, index) => (
            <Card key={index} item={item} />
          ))}
        </ul>
      </div>
    </React.Fragment>
  )
}

export default Container
